import React from 'react';
import { IAddCartInstance } from '@base/product/useAddCart';
import ProdQty from '@base/product/ProdQty';
import styles from './index.module.less';
import ProdBtns from '@base/product/ProdBtns';

type QtyBtnsProps = {
    addCart: IAddCartInstance;
    qtyShown?: boolean;
    btnsShown?: boolean;
}

const QtyBtns: React.FC<QtyBtnsProps> = props => {
    const {
        addCart,
        qtyShown = true,
        btnsShown = true,
    } = props;

    const {
        qty,
        onChangeQty,
    } = addCart;

    return (
        <div className={styles['qty-btns']}>
            {qtyShown && (
                <div className={styles['qty-wrap']}>
                    <ProdQty value={qty} onChange={onChangeQty} className="valign-top"/>
                </div>
            )}
            {btnsShown && (
                <div className={styles['btns-wrap']}>
                    <ProdBtns
                        addCart={addCart}
                        className={styles.btn}
                    />
                </div>
            )}
        </div>
    )
};

export default QtyBtns;
